<template>
  <div>
    <div class="container">   
      <div class="title">吉林市青年创业就业服务平台</div>   
      <el-dropdown>
        <div class="header">
          <div>{{header}}<i class="el-icon-caret-bottom arrow-down"></i></div>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      
     
    </div>
  </div>
</template>

<script>
import { store } from '../store';

    export default {
        data(){
            return {
                header:store.state.userInfo.name
            }
        },
      methods:{
        logout(){
          this.$store.commit("setUserInfo", {});
          this.$router.push(`/login`)
        }
      }
    }
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
.container{
  display: flex;
  flex-direction: row-reverse;
  /* flex-direction: row; */
  background-color: #e5e9f2;
  border: 1px solid black;
  width: 100%;
}
.title {
  width: 95%;
  order: 1;
  margin-right: 20px;
  font-size: 24px;
}
.header{
  order: 2;
  margin-right: 20px;
  /*border: 1px solid black;*/
}
.arrow-down{
  /*border:1px solid black;*/

}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue